export enum ToastType {
  BASIC = 'basic',
  DEFAULT = 'default',
  ACTION_BLOCKED = 'action_blocked',
  CUSTOM_ACTIONS = 'custom_actions',
}

export interface ToastItem {
  id: string;
  type?: ToastType;
  headerTitle?: string;
  content?: React.ReactNode | string;
  errorString?: string;
  variant?: 'success' | 'danger' | 'warning' | 'info';
  autohide?: boolean;
  delay?: number;
}
